import React from 'react'
import { Container, Spinner } from 'react-bootstrap'

interface EntityResolverLoadingProps {
  entityName: string
  progress?: string
}

export const EntityResolverLoading: React.FC<EntityResolverLoadingProps> = ({
  entityName,
  progress,
}) => {
  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '60vh' }}
    >
      <div className="text-center">
        <Spinner animation="border" variant="primary" className="mb-3" />
        <h4>Resolving Entity</h4>
        <p className="text-muted">Looking up '{entityName}'...</p>
        {progress && <p className="text-info mt-2">{progress}</p>}
      </div>
    </Container>
  )
}
